export const ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
export const CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
export const AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
export const TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
export const SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
export const ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
